import { refreshSession } from "../../SessionManagement/actionCreators/session"

export const mapState = () => ({})

export const mapDispatch = (dispatch) => ({
  refreshSession: (data) => dispatch(refreshSession({ ...data, dispatch })),
})
